import { HttpClient } from '@angular/common/http';import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { FilterModel } from '../models/filter';
import { icaoccModel } from '../models/icaoccModel';
import { EndpointsService } from './endpoints.service';
import { ToolsControlService } from './tools-control.service';
import { NavaidsService } from './navaids.service';

@Injectable({
  providedIn: 'root'
})
export class NavaidsFilterService {

  active : boolean = false;
  fullScreenMode : boolean = false;
  filters: FilterModel[] = [];
  windowOpened$ = new Subject<void>();
  
  ecacEnpIcaoCodes: icaoccModel[] = [];
  worldIcaoCodes: icaoccModel[] = [];

  constructor(private toolsService: ToolsControlService,
    private http: HttpClient,
    private endpointService: EndpointsService,
   ) { }

  openWindow():void {
    this.active = true;
    this.toolsService.navigationOnTop = true;
    this.windowOpened$.next();
  }

  initIcaoCodes() {
    this.getAllIcaoCountryCodes().subscribe((icaocodes) => {
      icaocodes.forEach(code => {
        this.worldIcaoCodes.push(new icaoccModel(code.countryname, code.fips, code.icaocode ?? 'null', code.iso2code));
        if (code.isecacenp) {
          this.ecacEnpIcaoCodes.push(new icaoccModel(code.countryname, code.fips, code.icaocode ?? 'null', code.iso2code));
        }
      });
      this.worldIcaoCodes = this.worldIcaoCodes.sort((a, b) => (a.countryname > b.countryname) ? 1 : ((b.countryname > a.countryname) ? -1 : 0));
      this.ecacEnpIcaoCodes = this.ecacEnpIcaoCodes.sort((a, b) => (a.countryname > b.countryname) ? 1 : ((b.countryname > a.countryname) ? -1 : 0));
    });
  }

  getAllIcaoCountryCodes(): Observable<icaoccModel[]> {
    return this.http.get<icaoccModel[]>(
      this.endpointService.icaoccUrl,
      this.endpointService.httpOptions
    );
  }

}
